import 'css-chunksrc/client/scenes/optimizedGantt/resources/group/styles.scss';export default {
  "group": "_group_tr3mh_1",
  "name": "_name_tr3mh_5",
  "header": "_header_tr3mh_12",
  "icon": "_icon_tr3mh_18",
  "iconBox": "_iconBox_tr3mh_26",
  "resource": "_resource_tr3mh_33"
};